import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import CompanyEditData from "./CompanyModel/CompanyEditData"

export function CompanyUpdateObservable(data: CompanyEditData): Observable<string> {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/UpdateClientInformation", requestBody)
}

export function CompanyCreateObservable(data: CompanyEditData): Observable<string> {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/CreateCompany", requestBody)
}